






import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Helpers
 */

/**
 * Utils
 */

/**
 * API
 */
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import DataFetcher from "@/components/_global/DataFetcher.vue";

/**
 * VueX Modules
 */
const teamModule = namespace("team");

@Component({
	components: {DataFetcher}
})
export default class AppTeamLayout extends Vue {
	/// Injections

	/// Properties

	/// Attributes

	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	@teamModule.State("isLoading")
	isLoading!: boolean;


	/// Methods
	async created() {
	}

	async fetch() {
		const teamInfos = this.$route.meta.teamInfos;
		await this.$team.fetch(teamInfos);
		
		await this.$teamHub.startSignalR(async () => {
			if (teamInfos.id) {
				await this.$teamHub.connectToGuild(teamInfos.id);
			}
		});
	}

	async destroyed() {
		await this.$teamHub.stopSignalR();
	}
}
